import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthState} from '@shared/state/auth/auth.state';
import {Select, Store} from '@ngxs/store';
import {map} from 'rxjs/operators';
import {CheckSession} from '@shared/state/auth/auth.actions';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  @Select(AuthState.getUserToken) userToken$: Observable<string>;

  constructor(private store: Store) {
  }

  /**
   * Standard auth guard with bare minimum requirement of being logged in
   * @param next
   * @param state
   */
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.store.selectOnce(AuthState.getUserToken).pipe(
      map(token => {
        if (token) {
          return true;
        }
        this.store.dispatch(new CheckSession({url: state.url, canNavigate: true}));
        return false;
      })
    );
  }
}
